import classNames from 'classnames'

import { Link } from 'react-router-dom'
import styles from './ShowMore.module.scss'

export const ShowMore = ({
  to,
  children,
  ...props
}: React.PropsWithChildren<React.ComponentProps<'div'>> & {
  to: string
}) => (
  <div {...props} className={classNames(styles.root, props.className)}>
    <Link to={to} className={styles.link}>
      {children}
    </Link>
  </div>
)
